module.exports = __webpack_public_path__ + "static/img/logo2.feb57882.png";